// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_lp-0";
export var discountCodeInput = "_lp-1";